'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import {
  MetaDefault,
  MonoDefault,
  MonoSmall,
} from '../../../../../components/typography';
import { renderHttpMethodText } from '../../../../../utils/http-badge.utils';
import type { ParsedHarEntry } from '../../ToolCallsRenderers/types';

type HttpExchangeRowsProps = {
  entries: ParsedHarEntry[];
};

export function HttpExchangeRows({ entries }: HttpExchangeRowsProps) {
  return (
    <VStack alignItems="stretch" gap={1.25} width="100%" overflowX="hidden">
      {entries.map((entry, index) => {
        const key = entry.id || `${entry.method}-${entry.url}-${index}`;

        return (
          <VStack key={key} alignItems="stretch" gap={0.25} width="100%">
            <HStack gap={1.5} alignItems="center" minWidth={0}>
              {entry.method ? renderHttpMethodText(entry.method) : null}
              <MonoDefault color="fg.default" truncate flex={1}>
                {entry.url || entry.id}
              </MonoDefault>
              {entry.responseStatus ? (
                <MonoSmall color="fg.muted">{entry.responseStatus}</MonoSmall>
              ) : null}
            </HStack>
            {entry.matchReason ? (
              <MetaDefault color="fg.muted" pl={0.5}>
                {entry.matchReason}
              </MetaDefault>
            ) : null}
          </VStack>
        );
      })}
    </VStack>
  );
}
